import { useState } from 'react';
import ListWithShowMoreLess from 'src/Admin/components/common/ListWithShowMoreLess';
import {
  TrashIcon,
  TrashIconDisable,
} from '../../../../../../img/findcare/FindCareSVG';
import DoctorIcon from 'src/Admin/img/persona-framework/doctor-icon.svg';
import GenericButton from '../../../../../../../Components/GenericButton/GenericButton';
import { maskTaxIDString } from 'src/common/masking';

import './doctorView.scss';

const DoctorViewPanel = ({
  selectedDoctors = [],
  onTrashButtonClickHandler,
  editAffiliatedRecords,
  onAddAllRecordsSameNPI,
  selectedAllDoctorsOfSameNPI,
  maskTaxId = false,
}) => {
  const [showMoreDoctors, setShowMoreDoctors] = useState(false);
  const [showMoreSpecialties, setShowMoreSpecialties] = useState(false);

  const addAllRecords = (NPI) => {
    onAddAllRecordsSameNPI(NPI);
  };

  const RenderDoctorListItem = ({ data }) => {
    const doctor = data;
    const SpecialtyText = ({ data, totalItemCount, index }) => (
      <span>
        {data}
        {totalItemCount > 1 && index === 0 ? ', ' : ' '}
      </span>
    );
    return (
      <div>
        <div className="selected-broker-item">
          <div className="d-flex broker-card">
            <div className="flex-1 d-flex">
              <div className="doc-icon d-flex mr-2">
                <img src={DoctorIcon} alt="doc icon" />
              </div>
              <div>
                <div className="blob-item-name-1">{`${doctor.LastName}, ${doctor.FirstName}`}</div>
                <div>
                  {doctor.Specialty ? (
                    <ListWithShowMoreLess
                      data={doctor?.Specialty?.split(',') || []}
                      RenderItemComponent={SpecialtyText}
                      showMore={showMoreSpecialties}
                      setShowMore={setShowMoreSpecialties}
                      initialNumberOfItems={2}
                      showMoreLessButtonClassName={'doc-specialty-show-more'}
                      disableShowMore={true}
                    />
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="d-dlex pt-2">
                <div className="blob-item-desc-2">
                  {doctor.NationalProviderId
                    ? `NPI: ${doctor.NationalProviderId}`
                    : ''}
                </div>
                <div className="blob-item-desc-3">
                  {doctor.TaxID && (
                    <div className="blob-item-desc-3">
                      Tax ID:{' '}
                      {maskTaxId ? maskTaxIDString(doctor.TaxID) : doctor.TaxID}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {onTrashButtonClickHandler ? (
              editAffiliatedRecords ? (
                <div className="trash-icon-div">
                  <button
                    type="button"
                    className="trash-button"
                    onClick={() => {
                      onTrashButtonClickHandler(
                        doctor.ConnectorID,
                        doctor.NationalProviderId,
                      );
                    }}
                  >
                    <TrashIcon />
                  </button>
                </div>
              ) : (
                <div className="trash-icon-div">
                  <button type="button" className="trash-button">
                    <TrashIconDisable />
                  </button>
                </div>
              )
            ) : null}
          </div>
        </div>
        {doctor.NationalProviderId &&
          doctor.NationalProviderId !== null &&
          selectedAllDoctorsOfSameNPI &&
          !selectedAllDoctorsOfSameNPI.includes(doctor.NationalProviderId) && (
            <div className="same-npi-records">
              <GenericButton
                variant="link"
                className="panel-card-link"
                onClick={() => addAllRecords(doctor.NationalProviderId)}
              >
                Add all records with the same NPI
              </GenericButton>
            </div>
          )}
      </div>
    );
  };

  return selectedDoctors?.length > 0 ? (
    <ListWithShowMoreLess
      data={selectedDoctors}
      RenderItemComponent={RenderDoctorListItem}
      showMore={showMoreDoctors}
      setShowMore={setShowMoreDoctors}
      showMoreLabel={'Doctors'}
    />
  ) : null;
};

export default DoctorViewPanel;
